var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 83,
    viewBox: "0 0 91 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M82.6249 61.1348V37.9923H48.8749V22.3497C53.2442 20.8053 56.375 16.6407 56.375 11.7422C56.375 5.5285 51.3387 0.492188 45.125 0.492188C38.9113 0.492188 33.875 5.5285 33.875 11.7422C33.875 16.6407 37.0058 20.8051 41.3751 22.3497V37.9923H7.62506V61.1348C3.25584 62.6794 0.125 66.8438 0.125 71.7423C0.125 77.956 5.16131 82.9923 11.375 82.9923C17.5887 82.9923 22.625 77.956 22.625 71.7423C22.625 66.8438 19.4942 62.6794 15.1249 61.1348V45.4922H41.3749V61.1348C37.0058 62.6794 33.875 66.8438 33.875 71.7423C33.875 77.956 38.9113 82.9923 45.125 82.9923C51.3387 82.9923 56.375 77.956 56.375 71.7423C56.375 66.8438 53.2442 62.6794 48.8749 61.1348V45.4922H75.1249V61.1348C70.7558 62.6792 67.625 66.8438 67.625 71.7423C67.625 77.956 72.6613 82.9923 78.875 82.9923C85.0887 82.9923 90.125 77.956 90.125 71.7423C90.125 66.8438 86.9942 62.6792 82.6249 61.1348Z",
    fill: "url(#paint0_linear_298_30630)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_298_30630",
    x1: 0.125,
    y1: 41.7422,
    x2: 90.1247,
    y2: 41.9051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D129DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CDBFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganization);
export default __webpack_public_path__ + "static/media/organization.b24528a9cc8c3b2b6ae69a454ede50f2.svg";
export { ForwardRef as ReactComponent };